import * as MovieApi from "movieapi";
import * as React from "react";
import SavePredictionForm from "./SavePredictionForm";

export interface IShowPredictionProps {
  prediction: MovieApi.Prediction | undefined;
  handleSavePrediction: (predictionName: string) => void;
}

export default class ShowPrediction extends React.Component<
  IShowPredictionProps,
  {}
> {
  constructor(props: IShowPredictionProps) {
    super(props);

    this.state = {};

    this.number_to_currency = this.number_to_currency.bind(this);
  }

  public render() {
    if (this.props.prediction !== undefined) {
      const forcePlotHmtl = this.props.prediction.forcePlotHtml;
      const js = forcePlotHmtl.split("<script>")[1].split("</script>")[0];
      window.setTimeout(() => {
        new Function(js)();
      }, 1000);
    }
    return (
      <div>
        {(this.props.prediction !== undefined && (
          <div style={{ textAlign: "center" }}>
            <p style={{ width: "30%", display: "inline-block" }}>
              The lower bound and upper bound represent a 95% confidence
              interval for the predicted revenue. A larger confidence interval
              reflects lower confidence in the predicted revenue. A smaller
              confidence interval reflects higher confidence in the predicted
              revenue. Below the predicted revenue we have a visual display of
              how the inputs are affecting the model. The base value represents
              the initial predicted revenue without prior information. The
              variables associated with the red arrows are pushing the predicted
              revenue higher. The variables associated with the blue arrows are
              pushing the predicted revenue lower. The size of the arrow
              represents how much the variable is pushing the prediction. There
              is a chance that the predicted revenue falls outside of the bounds
              of the confidence interval since the confidence interval cannot
              cover all possible outcomes. This may happen more often than
              expected on extremely popular movies since those movies are
              outliers.
            </p>
          </div>
        )) || <p>If you are done then hit predict to make a prediction.</p>}
        <br />
        {this.props.prediction !== undefined && (
          <React.Fragment>
            <h2>
              predicted revenue:{" "}
              {this.number_to_currency(this.props.prediction.revenue)}
            </h2>
            <h2>
              lower bound:{" "}
              {this.number_to_currency(this.props.prediction.lowerBound)}
            </h2>
            {/* <h2>
              median: {this.number_to_currency(this.props.prediction.median)}
            </h2> */}
            <h2>
              upper bound:{" "}
              {this.number_to_currency(this.props.prediction.upperBound)}
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.prediction.forcePlotHtml
              }}
            />
            <br />
            <SavePredictionForm
              handleSavePrediction={this.props.handleSavePrediction}
            />
          </React.Fragment>
        )}
      </div>
    );
  }

  private number_to_currency(num: number): string {
    const formatter = new Intl.NumberFormat("en-US", {
      currency: "USD",
      minimumFractionDigits: 2,
      style: "currency"
    });

    return formatter.format(num);
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/ShowPrediction.tsx